import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Modal from './Modal';
import CloseIcon from '../icons/CloseIcon';

const ConfirmationModal = props => {
  const { isOpen, close, apply, message } = props.state;

  const closeModal = e => {
    close();
    e.preventDefault();
  };

  return (
    <Modal isOpen={isOpen} close={close}>
      <div className="modal-confirmation">
        <div className="modal-notification-header">
          <a href="#" onClick={closeModal}>
            <CloseIcon color="#131925" opacity={0.6} />
          </a>
        </div>
        <p className="p-20px">{message}</p>
        <div className="is-flex align-items-center justify-content-between mt-20px is-fullwidth px-50px">
          <button className="button is-large is-danger" onClick={apply}>
            Yes
          </button>
          <button className="button is-large is-default" onClick={closeModal}>
            No
          </button>
        </div>
      </div>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  state: PropTypes.shape({
    isOpen: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    apply: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
  }).isRequired,
};

export const useConfirmationModal = message => {
  const [isOpen, setIsOpen] = useState(false);
  const [action, setAction] = useState(() => {});

  return {
    message: message || 'Are you sure?',
    isOpen,
    open: applyAction => {
      setAction(applyAction);
      setIsOpen(true);
    },
    close: () => {
      setIsOpen(false);
    },
    apply: () => {
      setIsOpen(false);
      action();
    },
  };
};

export default ConfirmationModal;
